import { QUERY_SEPARATOR, QUERY_PARAM_NAME } from '@yme/components/Comparison/constants';
export function getComparisonPageSearchParams(productKeys) {
    const searchParams = new URLSearchParams();
    searchParams.set(QUERY_PARAM_NAME, productKeys.join(QUERY_SEPARATOR));
    return searchParams.toString();
}
